export const categories = [
  { name: "Solvents & Reagents", slug: "solvents-reagents", icon: "🧪", count: 48 },
  { name: "Peptides", slug: "peptides", icon: "🧬", count: 76 },
  { name: "Buffers & Standards", slug: "buffers-standards", icon: "📊", count: 28 },
  { name: "Chromatography", slug: "chromatography", icon: "📈", count: 42 },
  { name: "Cell Culture", slug: "cell-culture", icon: "🧫", count: 31 },
  { name: "Lab Equipment", slug: "lab-equipment", icon: "⚗️", count: 56 },
  { name: "Research Chemicals", slug: "research-chemicals", icon: "🔬", count: 125 },
  { name: "Industrial Chemicals", slug: "industrial-chemicals", icon: "🏭", count: 57 },
  { name: "Pills and Painkillers", slug: "pills-painkillers", icon: "💊", count: 32 },
  { name: "Liquid Mercury", slug: "liquid-mercury", icon: "🪙", count: 7 },
  { name: "Cannabis", slug: "cannabis", icon: "🌿", count: 15 },
  { name: "Lab Supplies", slug: "lab-supplies", icon: "⚖️", count: 44 },
];
